<template>
  <button
    type="button"
    :style="[marginStyle, style]"
    class="btn btn-primary FormButton"
    :class="[{'btn-block': !inline}, theme]"
    v-bind="$attrs"
    @click="onClick"
  >
    <slot></slot>
  </button>
</template>

<script>
import marginProps from '@/mixins/marginProps'
export default {
  mixins: [marginProps],
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '50px'
    },
    inline: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'primary' // primary|danger|outline
    },
    fs: {
      type: String // font-size
    },
    radius: {
      type: String
    }
  },
  computed: {
    style () {
      return {
        width: this.width,
        height: this.height,
        fontSize: this.fs,
        borderRadius: this.radius
      }
    }
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style scoped lang="scss">
.FormButton {
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  background: #2d5bff;
  &:hover {
    background: #2650e7;
  }
  &[disabled] {
    cursor: not-allowed;
  }
  &.danger {
    @include bg-gradient(90deg, #fe6767, #f74959);
    &:hover {
      @include bg-gradient(90deg, darken(#fe6767, 10%), #f74959);
    }
  }
  &.normal {
    color: rgb(136, 141, 156);
    border: 1px solid rgb(208, 213, 216);
    box-shadow: none;
    @include bg-gradient(90deg, #fff, #fff);
    &:hover {
      @include bg-gradient(90deg, #fff, #fff);
    }
  }
  &.normal:active {
    color: rgb(136, 141, 156);
    background-color: #fff;
    background-image: none;
    border-color: rgb(208, 213, 216);
  }
  &.outline {
    color: #5866ec;
    background: #f7faff;
    border: 1px solid #5866ec;
    &:hover {
      color: darken(#5866ec, 10%);
    }
  }
}
</style>
